<template>
  <figure class="subject-image">
    <p v-if="hasError" class="subject-image__fallback" data-test-id="SubjectImage_Fallback">
      {{ label }}
    </p>
    <div v-else class="subject-image__frame">
      <button
        class="subject-image__expand-button"
        data-test-id="SubjectImage_ExpandButton"
        @click="mediaViewerUrl = url"
      />
      <img
        class="subject-image__image"
        data-test-id="SubjectImage_Image"
        :src="url"
        :alt="label"
        @error="hasError = true"
      />
    </div>
  </figure>
  <InterviewPageModal v-if="mediaViewerUrl">
    <MediaLayout :can-continue="true" @continue="mediaViewerUrl = undefined">
      <MediaImageViewer :url="mediaViewerUrl" />
      <template #button>
        {{ c('back_to_question') }}
      </template>
    </MediaLayout>
  </InterviewPageModal>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'

import MediaImageViewer from '../../../core/components/dumb/MediaImageViewer.vue'
import MediaLayout from '../../../core/components/dumb/MediaLayout.vue'
import InterviewPageModal from '../../../interview/components/dumb/InterviewPageOverlay.vue'
import { c } from '../../../intl'

export default defineComponent({
  components: {
    MediaImageViewer,
    MediaLayout,
    InterviewPageModal,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      hasError: ref(false),
      mediaViewerUrl: ref<string | undefined>(undefined),
      c,
    }
  },
})
</script>
<style lang="postcss">
.subject-image {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0 var(--attest-spacing-4);

  &__frame {
    position: relative;
    display: inline-flex;
    max-width: 100%;
  }

  &__expand-button {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 25px;
    height: 25px;
    border: 0;
    border-radius: 50%;
    background-color: var(--color-selected);
    background-image: url('../../../interview/assets/expand-white.svg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto 11px;
    cursor: pointer;
  }

  &__image {
    max-width: 100%;
    max-height: 180px;
    object-fit: contain;

    @media (width >= 640px) {
      max-height: 260px;
    }
  }

  &__fallback {
    margin: 0;
    color: #036;
    font-size: var(--attest-font-size-s);
    font-weight: 400;
    text-align: center;
  }
}
</style>
